import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import AboutUsSectionNavigationsDark1 from '../components/navigations-dark/AboutUsSectionNavigationsDark1';
import AboutUsSectionDashboardPageHeadings9 from '../components/dashboard-page-headings/AboutUsSectionDashboardPageHeadings9';
import AboutUsSectionCtaWhitePattern5 from '../components/cta-white-pattern/AboutUsSectionCtaWhitePattern5';
import AboutUsSectionTeamWhitePattern6 from '../components/team-white-pattern/AboutUsSectionTeamWhitePattern6';
import AboutUsSectionFaqsWhitePattern7 from '../components/faqs-white-pattern/AboutUsSectionFaqsWhitePattern7';

const meta = {
  title: 'About Us | Bagga International',
  meta: [
    { name: 'description', content: 'Learn more about Bagga International, our mission, and our commitment to quality in tool bags, pouches, and belts.' },
    { property: 'og:title', content: 'About Us | Bagga International' },
    { property: 'og:description', content: 'Learn more about Bagga International, our mission, and our commitment to quality in tool bags, pouches, and belts.' },
    { property: 'og:image', content: '/images/site-default-og.jpg' },
    { property: 'og:type', content: 'website' },
    { property: 'og:url', content: 'https://baggainternational.com/about-us' },
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:title', content: 'About Us | Bagga International' },
    { name: 'twitter:description', content: 'Learn more about Bagga International, our mission, and our commitment to quality in tool bags, pouches, and belts.' },
    { name: 'twitter:image', content: '/images/site-default-og.jpg' }
  ],
  link: [
    { rel: 'canonical', href: 'https://baggainternational.com/about-us' }
  ],
  style: [],
  script: [],
};

export default function About_us() {
  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet {...meta}></Helmet>
      </HelmetProvider>
      <AboutUsSectionDashboardPageHeadings9 />
      <AboutUsSectionCtaWhitePattern5 />
      <AboutUsSectionTeamWhitePattern6 />
      <AboutUsSectionFaqsWhitePattern7 />
    </React.Fragment>
  );
}

